/* ============================================================
   Bariera — tło WebGL pod całą stroną
   Kaustyki (refrakcja światła w cieczy) na jednym płótnie
   przypiętym do viewportu. Bez bibliotek zewnętrznych.
   Sterowanie: window.BarieraBG z ustawień motywu.
   ============================================================ */
(function () {
  "use strict";

  var cfg = window.BarieraBG || {};
  if (cfg.enabled === false) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var coarse = window.matchMedia("(pointer: coarse)").matches;

  // Na telefonach domyślnie zostaje statyczny gradient (#bgfb) — oszczędza baterię i LCP.
  if (coarse && !cfg.mobile) return;

  var canvas = document.getElementById("bggl");
  if (!canvas) return;

  var gl = null;
  try {
    gl = canvas.getContext("webgl", { antialias: false, alpha: false, powerPreference: "low-power" }) ||
         canvas.getContext("experimental-webgl");
  } catch (e) { gl = null; }
  if (!gl) { canvas.style.display = "none"; return; }

  var VS = "attribute vec2 p;void main(){gl_Position=vec4(p,0.0,1.0);}";

  var FS = [
    "precision mediump float;",
    "uniform vec2 u_res;uniform float u_t;uniform vec2 u_m;uniform vec2 u_sp;uniform float u_int;uniform float u_drift;",
    "const float TAU=6.28318530718;",
    "float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453123);}",
    "float vnoise(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.0-2.0*f);",
    " return mix(mix(hash(i),hash(i+vec2(1.0,0.0)),u.x),mix(hash(i+vec2(0.0,1.0)),hash(i+vec2(1.0,1.0)),u.x),u.y);}",
    "void main(){",
    " vec2 uv=(gl_FragCoord.xy-0.5*u_res)/u_res.y;",
    " vec2 fuv=gl_FragCoord.xy/u_res.y;",
    " float t=u_t*0.30+4.0;",
    // u_sp.x = pozycja w dokumencie 0..1, u_sp.y = wyjście z hero 0..1
    " float journey=u_sp.x*u_drift;",
    " float calm=u_sp.y;",
    " float amp=mix(1.0,0.34,calm)*u_int;",
    " fuv+=vec2(0.0,u_sp.x*2.4);",
    // --- kaustyki ---
    " vec2 p=mod(fuv*TAU*0.95+u_m*0.8,TAU)-250.0;",
    " vec2 q=p;float c=1.0;float inten=0.0045;",
    " for(int n=0;n<4;n++){",
    "  float tt=t*(1.0-(3.5/float(n+1)));",
    "  q=p+vec2(cos(tt-q.x)+sin(tt+q.y),sin(tt-q.y)+cos(tt+q.x));",
    "  c+=1.0/length(vec2(p.x/(sin(q.x+tt)/inten),p.y/(cos(q.y+tt)/inten)));",
    " }",
    " c/=4.0;c=1.17-pow(c,1.4);",
    " float a=abs(c);",
    // rozszczepienie chromatyczne na krawędziach siatki
    " vec3 web=clamp(vec3(pow(a,6.4),pow(a,7.6),pow(a,9.4)),0.0,1.0);",
    // --- płynne tło pod kaustykami ---
    " vec2 nuv=uv+vec2(0.0,u_sp.x*3.2);",
    " float n1=vnoise(nuv*1.25+vec2(t*0.10,-t*0.07));",
    " float n2=vnoise(nuv*2.70-vec2(t*0.06,t*0.09));",
    " float fld=n1*0.68+n2*0.32;",
    " float pool=smoothstep(0.30,0.82,fld);",
    " float warm=smoothstep(0.42,0.92,1.0-fld);",
    " vec3 bone=vec3(0.933,0.945,0.918);",
    // barwa wędruje ze scrollem: błękit → zieleń → piasek
    " vec3 coolA=vec3(0.612,0.686,0.855);",
    " vec3 coolB=vec3(0.573,0.749,0.702);",
    " vec3 coolC=vec3(0.878,0.827,0.686);",
    " float j2=clamp(journey*2.0,0.0,1.0);",
    " float j3=clamp((journey-0.5)*2.0,0.0,1.0);",
    " vec3 cool=mix(mix(coolA,coolB,j2),coolC,j3);",
    " vec3 deep=mix(vec3(0.239,0.310,0.663),vec3(0.176,0.373,0.318),clamp(journey*1.4,0.0,1.0));",
    " vec3 sand=vec3(0.922,0.882,0.757);",
    " vec3 col=mix(bone*0.90,bone,smoothstep(-0.80,0.70,uv.y+0.20*sin(uv.x*1.6+t*0.25)));",
    " col=mix(col,cool,pool*mix(0.72,0.46,calm));",
    " col=mix(col,deep,pow(pool,3.0)*mix(0.42,0.16,calm));",
    " col=mix(col,sand,warm*0.34);",
    " col=mix(col,bone,calm*0.16);",
    " col+=web*vec3(0.58,0.66,0.88)*1.25*amp;",
    " col=mix(col,vec3(1.0,1.0,0.995),clamp(web.g,0.0,1.0)*0.42*amp);",
    " col*=1.0-0.22*smoothstep(0.48,1.45,length(uv*vec2(0.78,1.0)))*(1.0-calm*0.6);",
    " col+=(hash(gl_FragCoord.xy+fract(u_t))-0.5)*0.020;",
    " gl_FragColor=vec4(clamp(col,0.0,1.0),1.0);",
    "}"
  ].join("\n");

  function compile(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
  }

  var vs = compile(gl.VERTEX_SHADER, VS);
  var fs = compile(gl.FRAGMENT_SHADER, FS);
  if (!vs || !fs) { canvas.style.display = "none"; return; }

  var prog = gl.createProgram();
  gl.attachShader(prog, vs);
  gl.attachShader(prog, fs);
  gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { canvas.style.display = "none"; return; }
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, "p");
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

  var uRes = gl.getUniformLocation(prog, "u_res");
  var uT = gl.getUniformLocation(prog, "u_t");
  var uM = gl.getUniformLocation(prog, "u_m");
  var uSp = gl.getUniformLocation(prog, "u_sp");
  var uInt = gl.getUniformLocation(prog, "u_int");
  var uDrift = gl.getUniformLocation(prog, "u_drift");

  gl.uniform1f(uInt, typeof cfg.intensity === "number" ? cfg.intensity : 1.0);
  gl.uniform1f(uDrift, cfg.drift === false ? 0.0 : 1.0);

  var mx = 0, my = 0, mtx = 0, mty = 0;
  var sp = 0, spT = 0, calm = 0, calmT = 0;

  function readScroll() {
    var h = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    spT = Math.min(1, Math.max(0, window.scrollY / h));
    calmT = Math.min(1, window.scrollY / Math.max(1, window.innerHeight * 0.85));
  }

  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 1.25);
    canvas.width = Math.max(1, Math.floor(window.innerWidth * dpr));
    canvas.height = Math.max(1, Math.floor(window.innerHeight * dpr));
    gl.viewport(0, 0, canvas.width, canvas.height);
    gl.uniform2f(uRes, canvas.width, canvas.height);
  }

  resize();
  readScroll();
  window.addEventListener("resize", function () { resize(); readScroll(); });
  window.addEventListener("scroll", readScroll, { passive: true });
  window.addEventListener("mousemove", function (e) {
    mtx = (e.clientX / window.innerWidth - 0.5) * 2;
    mty = -(e.clientY / window.innerHeight - 0.5) * 2;
  }, { passive: true });

  var start = performance.now();
  var drawn = false;

  (function frame(now) {
    requestAnimationFrame(frame);
    if (document.hidden) return;
    if (reduce && drawn) return;
    mx += (mtx - mx) * 0.045;
    my += (mty - my) * 0.045;
    sp += (spT - sp) * 0.09;
    calm += (calmT - calm) * 0.09;
    gl.uniform2f(uM, mx, my);
    gl.uniform2f(uSp, sp, calm);
    gl.uniform1f(uT, reduce ? 4.0 : (now - start) / 1000);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
    drawn = true;
  })(performance.now());
})();
